import { StudentAvailability } from "@/pages/cursisten/$studentId/beschikbaarheid"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/cursisten/$studentId/beschikbaarheid/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "students"),
})

function RouteComponent() {
  const { studentId } = useParams({ from: "/beheer/cursisten/$studentId" })

  return <StudentAvailability studentId={Number(studentId)} />
}
